import { apiFunction } from "../../apiCall/function"

export const reReregister = async (data) => {
  return await apiFunction("form/reregister", "post", data, true, 'body')
}